import { AbsenceRepo } from "@/modules/working_hours/domain/AbsenceRepo";
import { Absence } from "@/modules/working_hours/domain/Absence";
import { CalendarAbsence } from "@/modules/working_hours/app/CalendarAbsences";

export class LoadAbsence {
  private repo: AbsenceRepo;
  private screen_data: { absences: Absence[] };

  constructor(repo: AbsenceRepo, screen_data: { absences: Absence[] }) {
    this.repo = repo;
    this.screen_data = screen_data;
  }

  filterAbsencesByMonth(month: number, year: number): Absence[] {
    return this.screen_data.absences.filter(absence => {
      const absenceDate = new Date(absence.start);
      return absenceDate.getMonth() === month && absenceDate.getFullYear() === year;
    });
  }

  async load(user_id?: number) {
    try {
      this.screen_data.absences = await this.repo.find_all(user_id);
    } catch (error) {
      this.screen_data.absences = [];
    }
  }
}